import { render } from "./AddPartenaire.vue?vue&type=template&id=f7c7eca8&ts=true"
import script from "./AddPartenaire.vue?vue&type=script&lang=ts"
export * from "./AddPartenaire.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__